import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterContainerSectionLabel from './VeltCommentsSidebarV2FilterContainerSectionLabel/VeltCommentsSidebarV2FilterContainerSectionLabel';
import VeltCommentsSidebarV2FilterContainerSectionField from './VeltCommentsSidebarV2FilterContainerSectionField/VeltCommentsSidebarV2FilterContainerSectionField';
var VeltCommentsSidebarV2FilterContainerSection = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-section-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterContainerSection.Label = VeltCommentsSidebarV2FilterContainerSectionLabel;
VeltCommentsSidebarV2FilterContainerSection.Field = VeltCommentsSidebarV2FilterContainerSectionField;
export default VeltCommentsSidebarV2FilterContainerSection;
